export default {
    /** 禁用加载更多功能 */
    disabledInfinite: false,
    /** 禁用下拉刷新功能 */
    disabledRefresh: false,
    /** 刷新后滚动位置保持 */
    refreshScrollKeep: false,
    /** 关闭webkit的快速滚动 */
    disabledScrolling: false,
    /** 新页加载时的提示文本 */
    infiniteText: "加载中...",
    /** 尾页提示文本 */
    endText: "没有更多了",
    /** 下拉时的提示文本 */
    refreshPullText: "下拉更新",
    /** 下拉时的松开提示文本 */
    refreshLoosenText: "松开更新",
    /** 提示文本及加载图标的颜色 */
    color: "#999"
}
